module.exports = __webpack_public_path__ + "media/images/ic-photo-a25154f7831fb82d052f86a874a9edbc.svg";